import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { CssSelectors, FontFamilies } from '../../../../web/styles/styles';
import { backgroundGreen, brandPrimary, brandSecondary, gold, white } from '../../../styles/colors';
import { aidaBaseStyles } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	companyLink: {
		textDecoration: 'none',
		justifyContent: 'flex-start',
		textAlign: 'start',
		fontSize: 16,
		':hover': {
			textDecoration: 'none',
		},
	},
	root: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	container: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'hidden',
	},
	containerInner: {
		width: '100%',
		maxWidth: 1400,
		overflowX: 'hidden',
		margin: '0 auto',
		paddingRight: 16,
		paddingLeft: 16,
		paddingBottom: 16,
		marginTop: 16,
		flex: 1,
	},
	content: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		borderRadius: 8,
		backgroundColor: white,
		color: THEME.colors.text.dark,
		height: '100%',
	},
	header: {
		marginBottom: 24,
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	title: {
		fontSize: 24,
		fontWeight: 'bold',
	},
	description: {
		margin: 0,
		padding: 0,
	},
	audioColumn: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
	},
	copyAudioLink: {
		display: 'flex',
		padding: 12,
		paddingLeft: 0,
		...CssSelectors.allChildren(
			{
				height: 14,
				width: 14,
			},
			'svg'
		),
		...CssSelectors.allChildren(
			{
				marginRight: 5,
				marginTop: -4,
			},
			':first-child:not(svg)'
		),
	},
	dot: {
		borderRadius: '50%',
		height: 10,
		marginLeft: 5,
		width: 10,
	},
	empty: {
		padding: 12,
		paddingLeft: 0,
	},
	followUpClockIcon: {
		marginLeft: 10,
		...CssSelectors.allChildren(
			{
				height: 14,
				width: 14,
			},
			'svg'
		),
	},
	followUpContainer: {
		background: brandSecondary,
		borderRadius: 14,
		display: 'inline-block',
		height: '50',
		padding: '10px 14px',
		width: '100',
		...CssSelectors.allDescendants({
			fontFamily: FontFamilies.semiBold,
		}),
	},
	followUpName: {
		':nth-child(1n)': {
			fontFamily: FontFamilies.regular,
		},
		color: white,
		marginLeft: 10,
	},
	followUpOverdue: {
		color: `${gold} !important`,
	},
	fontSizeSmall: {
		fontSize: 14,
	},
	iconPosition: {
		marginBottom: -1,
		marginLeft: 6,
	},
	label: {
		display: 'inline-block',
		fontSize: '11px',
		minWidth: 90,
		textAlign: 'right',
		textTransform: 'uppercase',
	},
	lastDealContainer: {
		background: backgroundGreen,
		borderRadius: 14,
		color: brandPrimary,
		display: 'inline-block',
		height: '50',
		padding: '10px 14px',
		width: '100',
		...CssSelectors.allDescendants({
			color: brandPrimary,
			fontFamily: FontFamilies.semiBold,
		}),
	},
	lastInteraction: {
		...aidaBaseStyles.flexHorizontalCenter,
		':first-child': {
			marginBottom: 4,
		},
		...CssSelectors.allChildren(
			{
				fontSize: '12px',
				paddingLeft: 5,
			},
			'span:last-child'
		),
	},
	link: {
		color: brandSecondary,
	},
	pepper: {
		height: 16,
		marginLeft: 10,
		width: 16,
	},
	recordingLink: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		fontFamily: FontFamilies.semiBold,
		fontSize: 'inherit',
		padding: 0,
		textDecoration: 'underline',
		':hover': {
			opacity: 0.8,
		},
	},
	reportLink: {
		color: 'white',
	},
	transcriptionComponents: {
		...CssSelectors.allDescendants(
			{
				marginTop: 4,
			},
			'.transcription-icon'
		),
	},
});
